import * as React from 'react';
import { IconTrust16 } from '@cian/ui-kit/icons';
import { UIText3 } from '@cian/ui-kit/typography';
import { clsx } from 'clsx';

import * as styles from './styles.css';

export interface IReliableLabelProps {
  light?: boolean;
  onOpen?(): void;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
}

export function ReliableLabel({ onOpen, onClick, light }: IReliableLabelProps) {
  return (
    <div
      className={clsx(styles['container'], styles['reliable'], light && styles['reliable-light'])}
      onMouseEnter={onOpen}
      onClick={onClick}
    >
      <IconTrust16 color={light ? 'primary_100' : 'white_100'} />
      <div className={styles['text']}>
        <UIText3 color={light ? 'primary_100' : 'white_100'}>Надёжный корпус</UIText3>
      </div>
    </div>
  );
}
